<template>
  <footer>
    <div class="copyright">
      <p>© 2023 Developed by YuChing Su & Haoyun Wu</p>
    </div>
  </footer>
</template>

<style scoped>
.copyright p {
  color: #585858;
  font-size: 14px;
}
</style>